module.exports = __webpack_public_path__ + "img/Papua New Guinea.8109dff9.svg";